import React, { useState } from 'react'
import { Alert, Chevron } from 'src/assets/index'
import { UserProfile } from 'src/components/HomePage/UserProfile'
import useUserData from 'src/hooks/useUserData'
import { ProfileNavModal } from '../Modal'
import { Profiler } from './style'
const SideProfile = (props: any) => {
  const data = useUserData()
  const profile_picture = data?.user?.profile_picture
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    setShowModal((prev) => !prev)
  }
  return (
    <Profiler>
      {/* <div className="alert">
        <img src={Alert} alt="" />
      </div> */}
      <div className="picture" onClick={openModal}>
        <img src={profile_picture} alt="" className="picture-width" />
        <img className="pictureimg" src={Chevron} alt="" />
      </div>
      <ProfileNavModal showModal={showModal} setShowModal={setShowModal}>
        <UserProfile />
      </ProfileNavModal>
    </Profiler>
  )
}
export { SideProfile }
